import type { UnitInfoMobileJawAndConeInterface } from 'store/units/types';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { MobileJawAndConeUnitInfoDataInterface } from './unitInfoData';

export class MobileJawAndConeConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoMobileJawAndConeInterface {
    const unitInfoData =
      (params?.data as MobileJawAndConeUnitInfoDataInterface | undefined) ?? {};
    const defaultModel = Object.entries(unitInfoData)[0];
    const model = defaultModel[0];
    const modelData = defaultModel[1];

    return {
      ...BaseUnitConfig.getBaseDefaults(),
      modelName: model,
      configuration: modelData.configurations.configurationOptions[0],
      numberOfPorts: 5,
      moisture: 0,
      newMoisture: false,
      JAW1: {
        modelName: modelData.jawCrusherModel,
        css: modelData.configurations.defaultJawCss,
      },
      CONE1: {
        modelName: modelData.coneCrusherModel,
        mantle: modelData.configurations.defaultConeMantle,
        concave: modelData.configurations.defaultConeChaber,
        unitThrow: modelData.configurations.defaultThrow,
        css: modelData.configurations.defaultConeCss,
      },
      GRIZZLY_FEEDER1: {
        modelName: modelData.grizzlyModel,
        decks: {
          0: {
            separationSize: modelData.configurations.defaultGrizzlySepSize1,
          },
          1: {
            separationSize: modelData.configurations.defaultGrizzlySepSize2,
          },
        },
      },
      CONVENTIONAL_SCREEN1: {
        decks: {
          0: {
            separationSize: modelData.configurations.screenDeck1Default,
          },
          1: {
            separationSize: modelData.configurations.screenDeck2Default,
          },
        },
      },
      CONVENTIONAL_SCREEN2: {
        decks: {
          0: {
            separationSize: modelData.configurations.screenDeck3Default,
          },
          1: {
            separationSize: modelData.configurations.screenDeck4Default,
          },
        },
      },
      CONVENTIONAL_SCREEN3: {
        decks: {
          0: {
            separationSize: modelData.configurations.screenDeck4Default,
          },
        },
      },
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayConfig: false,
        displayLoad: true,
        displayJawCrusherModel: false,
        displayJawCrusherCss: false,
        displayConeCrusherModel: false,
        displayConeCrusherThrow: false,
        displayConeCrusherCss: false,
        displayFeederModel: false,
        displayFeederSepSize: false,
        displayScreenModel: false,
        displayScreenSepSize: false,
      },
      parallelUnits: 1,
    };
  }

  static getNumberOfPorts(_model?: string, _config?: number): number {
    return 6;
  }
}

export const mobileJawAndConeConfig = new MobileJawAndConeConfig();

export const getNumberOfPorts = (configKey: number) => {
  if (configKey === 0) return 5;
  return 4;
};
